<template>
  <smallModal @escape="$emit('close')">
    <div class="transfer-div">
      <h5>{{ companyData.company_name }}</h5>
      <hr>
      <div class="login-div">
        <label for="newMaster">{{ lang['NewOwner'] }} <span class="grey-tip">({{ lang['EMailOrPhone'] }})</span></label>
        <b-form-input class="login-input" v-model="form.newMaster" autofocus name="newMaster" />
        <span class="red-tip">{{ lang['UserMustBeRegistered'] }}</span>
      </div>
      <div v-if="ccc != null">
        <div class="buttons-flex-end">
          <button @click="captchaImg" class="btn">
            <b-icon-arrow-repeat id="captcha-transfer"></b-icon-arrow-repeat>
          </button>
        </div>
        <div class="imgDiv">
          <img :src="ccc" class="capImg">
        </div>
        <label :for="captchaName">{{ lang['EnterCaptcha'] }}</label>
        <b-form-input v-model="form.captcha" :state="capState" :name="captchaName" />
      </div>
      <div class="transfer-company-pass">
        <label for="accountPassword">{{ lang['Password'] }}</label>
        <b-form-input v-model="form.accountPassword" id="input-password" type="password" :state="passState"
          name="accountPassword" />
        <span v-if="passState" @click="showPass" :class="isPassVisible ? 'icon-eye' : 'icon-eye-blocked'"></span>
      </div>
      <hr>
      <div class="buttons">
        <button class="btn btn-secondary" @click="$emit('close')">{{ lang['Сancel'] }}</button>
        <button class="btn btn-success longWord" @click="save">{{ lang['Confirm'] }}</button>
      </div>
    </div>
  </smallModal>
</template>

<script>
import { store } from '@/store.js'; // Глобальне сховище даних
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { rotate } from '../js/rotateBtn' // Імпортуємо функцію rotate для обертання елемента на 180 градусів з анімацією
import { guid } from '../js/guid.js'; // Імпортуємо функцію guid для створення унікальних ідентифікаторів
import { errList } from '../js/CaptchaAndPassError'; // Імпортуємо функцію errList для обробки різних помилок
import { regAPi } from '@/API.js';
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна

const apiList = new regAPi();
export default {
  props: ['companyData'],
  components: {
    smallModal
  },
  data() {
    return {
      form: {
        newMaster: '',
        accountPassword: '',
        captcha: '',
        captcha_guid: ''
      },
      ccc: null,
      captchaName: 'captcha_' + this.getRandNum(999, 99999),
      isPassVisible: false
    }
  },
  created() {
    this.captchaImg()
  },
  mounted() {
    keyevent.$off('enter');
    keyevent.$on('enter', () =>
      this.save()
    );
  },
  methods: {
    getRandNum(min, max) {
      return Math.random() * (max - min) + min;
    },
    captchaImg() {
      try {
        // создаем гуид (файл guid.js) который скидываем для капичи состарта, потом, если юзер нажал сохранить, то скидываем текущий гуид на сервак для сравнения
        const a = guid();
        const c = apiList.captchaUID(a);
        this.ccc = c;
        this.form.captcha_guid = a;
        // крутилка для кнопки
        rotate('#captcha-transfer');
        this.form.captcha = ''
      } catch (err) {
        console.log(err)
      }
    },
    showPass() {
      this.isPassVisible = !this.isPassVisible
      const input = document.getElementById('input-password');
      if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text');
      } else {
        input.setAttribute('type', 'password');
      }
    },
    save() {
      try {
        // для передачи компании новому владельцу передаем текущий токен, логин нового владельца(он должен быть зареган), ну и ИД компании которую передае
        if (this.passState && this.form.newMaster != '' && this.capState) {
          apiList.transferCompany({ token: store.token, ...this.form, company_id: this.companyData.company_id }).then(resp => {
            if (resp.data.status == 'done') {
              window.say.message(this.lang['Saved']);
              this.$emit('close');
            } else if (resp.data.error == "New owner is not registered") {
              window.say.messageError(this.lang['thisUserNorRegistered']);
            } else if (resp.data.error == "Captcha is incorrect") {
              window.say.messageError(this.lang['IncorrectCaptcha']);
            } else if (resp.data.error == "Captcha dont exist") {
              window.say.messageError(this.lang['CaptchaIsNotValid']);
            } else if (resp.data.error == "Password is incorrect") {
              window.say.messageError(this.lang['WrongPassword']);
            } else if (resp.data.error == "User is not owner of company") {
              window.say.messageError(this.lang['youNotOwner']);
            } else if (resp.data.error == "Сannot be transferred to oneself") {
              window.say.messageError(this.lang['cantTransferToYou']);
            } else {
              errList(resp.data.error[0]);
            }
          })
        } else {
          window.say.messageError(this.lang['FillInAllTheFields']);
        }
      } catch (err) {
        //
      }
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang
    },
    passState() {
      return this.form.accountPassword.length >= 1 ? true : false;
    },
    capState() {
      return this.form.captcha.length == 4 ? true : false;
    }
  }
}
</script>

<style scoped>
.longWord {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-eye,
.icon-eye-blocked {
  position: absolute;
  right: 40px;
  top: 58.5%;
}

.btn-secondary,
.btn-success {
  width: 49%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.imgDiv {
  text-align: center;
  height: 100px;
}

.capImg {
  height: 100px;
}

#captcha-transfer {
  height: 2rem;
  width: 2rem;
}

.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}


.buttons-flex-end {
  display: flex;
  justify-content: flex-end;
}

.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}

.red-tip {
  color: red;
  font-size: 0.8rem;
}

.login-input {
  margin-bottom: 0 !important;
}

.grey-tip {
  color: gray;
  font-size: 0.8rem;
}

.login-div {
  margin-bottom: 1rem;
}
</style>